import $ from 'jquery'

export class Tracking {
  constructor() {
    this.expr = /^(data\-dl\-).+/
    this.track($('body'))
  }

  track($parent) {
    this.handleLinks($parent, '[data-dl]')
  }

  handleLinks($parent, $selector) {
    $parent.on('click', $selector, (event) => {
      const element = event.currentTarget
      const vars = {}
      const dataAttributes = element.attributes

      // Test all the attributes
      for (let i = 0; i < dataAttributes.length; i++) {
        const name = dataAttributes[i].nodeName
        const value = dataAttributes[i].nodeValue

        if (this.expr.test(name)) {
          if (name === "data-dl-link-url") {
            if (value) {
              vars["link-url"] = value
            } else {
              vars["link-url"] = element.href
            }
          } else if (name === "data-dl-link-text") {
            if (value) {
              vars["link-text"] = value
            } else {
              vars["link-text"] = element.innerText
            }
          } else {
            const nameClean = name.replace(/data-dl-/g, '')
            vars[nameClean] = value
          }
        }
      }
      this.addDataToLayer(vars)
    })
  }

  // Optimisation
  addDataToLayer(vars) {
    window.dataLayer = window.dataLayer || []
    dataLayer.push(vars)
  }
}

